
const prepareShow = unit => {
  return unit
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  getTenantUnits (unit) {
    const params = {
      unit_id: unit.unit_id,
      tower_id: unit.tower_id
    }
    this.$http.post('/v1/dweller/unit/tenant/search', params)
      .then((data) => {
        console.log(data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/unit/index/resources/methods.js